import Logo from "../logo/Logo";
import Input from "../search/Input";
import useAuth from "../../hooks/useAuth";
import profile from "../../assets/thrifit-profile.svg";
import { Link, useLocation } from "react-router-dom";

const Menu = ({ sidebar, closeSidebar }) => {
  const { user, profile_image } = useAuth();

  const location = useLocation();

  return (
    <div
      className={`pt-2 pr-5 pl-5 z-50 bg-slate-50 h-screen block md:hidden w-4/6 absolute shadow-xl top-0 duration-500 ease-linear left-0 ${
        sidebar ? "-translate-x-0" : "-translate-x-full"
      }`}
    >
      <div className="w-fit ">
        <Logo />
      </div>

      <Input width="w-full" height="h-12" />

      <div className="mt-10 flex flex-col gap-10">
        <Link to="/communities">
          <div
            className={`${
              location.pathname === "/communities"
                ? "text-logoRed"
                : "text-black"
            } flex gap-5 items-center cursor-pointer w-fit`}
            onClick={() => closeSidebar(false)}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="10"
              height="10"
              fill="currentColor"
              className="bi bi-flag h-iconHeight w-iconWidth"
              viewBox="0 0 16 16"
            >
              <path d="M14.778.085A.5.5 0 0 1 15 .5V8a.5.5 0 0 1-.314.464L14.5 8l.186.464-.003.001-.006.003-.023.009a12.435 12.435 0 0 1-.397.15c-.264.095-.631.223-1.047.35-.816.252-1.879.523-2.71.523-.847 0-1.548-.28-2.158-.525l-.028-.01C7.68 8.71 7.14 8.5 6.5 8.5c-.7 0-1.638.23-2.437.477A19.626 19.626 0 0 0 3 9.342V15.5a.5.5 0 0 1-1 0V.5a.5.5 0 0 1 1 0v.282c.226-.079.496-.17.79-.26C4.606.272 5.67 0 6.5 0c.84 0 1.524.277 2.121.519l.043.018C9.286.788 9.828 1 10.5 1c.7 0 1.638-.23 2.437-.477a19.587 19.587 0 0 0 1.349-.476l.019-.007.004-.002h.001M14 1.221c-.22.078-.48.167-.766.255-.81.252-1.872.523-2.734.523-.886 0-1.592-.286-2.203-.534l-.008-.003C7.662 1.21 7.139 1 6.5 1c-.669 0-1.606.229-2.415.478A21.294 21.294 0 0 0 3 1.845v6.433c.22-.078.48-.167.766-.255C4.576 7.77 5.638 7.5 6.5 7.5c.847 0 1.548.28 2.158.525l.028.01C9.32 8.29 9.86 8.5 10.5 8.5c.668 0 1.606-.229 2.415-.478A21.317 21.317 0 0 0 14 7.655V1.222z" />
            </svg>
            <div className="font-Lato text-base font-normal">Communities</div>
          </div>
        </Link>

        <Link to="/explore">
          <div
            className={`${
              location.pathname === "/explore" ? "text-logoRed" : "text-black"
            } flex gap-5 items-center cursor-pointer w-fit`}
            onClick={() => closeSidebar(false)}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="10"
              height="10"
              fill="currentColor"
              className="bi bi-compass h-iconHeight w-iconWidth"
              viewBox="0 0 16 16"
            >
              <path d="M8 16.016a7.5 7.5 0 0 0 1.962-14.74A1 1 0 0 0 9 0H7a1 1 0 0 0-.962 1.276A7.5 7.5 0 0 0 8 16.016zm6.5-7.5a6.5 6.5 0 1 1-13 0 6.5 6.5 0 0 1 13 0z" />
              <path d="M6.94 7.44l4.95-2.83-2.83 4.95-4.949 2.83 2.828-4.95z" />
            </svg>
            <div className="font-Lato text-base font-normal">Explore</div>
          </div>
        </Link>

        <Link to="/cart">
          <div
            className={`flex gap-5 items-center cursor-pointer w-fit ${
              location.pathname === "/cart" ? "text-logoRed" : "text-black"
            }`}
            onClick={() => closeSidebar(false)}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="10"
              height="10"
              fill="currentColor"
              className="bi bi-cart2 h-iconHeight w-iconWidth"
              viewBox="0 0 16 16"
            >
              <path d="M0 2.5A.5.5 0 0 1 .5 2H2a.5.5 0 0 1 .485.379L2.89 4H14.5a.5.5 0 0 1 .485.621l-1.5 6A.5.5 0 0 1 13 11H4a.5.5 0 0 1-.485-.379L1.61 3H.5a.5.5 0 0 1-.5-.5zM3.14 5l1.25 5h8.22l1.25-5H3.14zM5 13a1 1 0 1 0 0 2 1 1 0 0 0 0-2zm-2 1a2 2 0 1 1 4 0 2 2 0 0 1-4 0zm9-1a1 1 0 1 0 0 2 1 1 0 0 0 0-2zm-2 1a2 2 0 1 1 4 0 2 2 0 0 1-4 0z" />
            </svg>
            <div className="font-Lato text-base font-normal">Cart</div>
          </div>
        </Link>

        {user?.data ? (
          <Link to="/profile">
            <div
              className={`${
                location.pathname === "/profile" ? "text-logoRed" : "text-black"
              } w-fit flex gap-5 items-center cursor-pointer`}
              onClick={() => closeSidebar(false)}
            >
              {profile_image ? (
                <img
                  src={profile_image}
                  className="m-auto h-iconHeight w-iconWidth rounded-full"
                  alt="user"
                />
              ) : (
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="23"
                  height="23"
                  fill="currentColor"
                  className="bi bi-person m-auto h-iconHeight w-iconWidth"
                  viewBox="0 0 16 16"
                >
                  <path d="M8 8a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm2-3a2 2 0 1 1-4 0 2 2 0 0 1 4 0zm4 8c0 1-1 1-1 1H3s-1 0-1-1 1-4 6-4 6 3 6 4zm-1-.004c-.001-.246-.154-.986-.832-1.664C11.516 10.68 10.289 10 8 10c-2.29 0-3.516.68-4.168 1.332-.678.678-.83 1.418-.832 1.664h10z" />
                </svg>
              )}
              <div className="font-Lato text-base font-normal">
                {user?.data?.first_name || "Profile"}
              </div>
            </div>
          </Link>
        ) : (
          <Link to="/sign-in">
            <div
              className="w-fit flex gap-5 items-center cursor-pointer"
              onClick={() => closeSidebar(false)}
            >
              <img
                src={profile}
                alt="user profile"
                className="m-auto h-iconHeight w-iconWidth"
              />
              <div className="mt-1 font-Lato text-base font-normal">
                Sign-in
              </div>
            </div>
          </Link>
        )}
      </div>
    </div>
  );
};

export default Menu;
